import React, { useEffect, useState, useRef } from "react";
import "../styles/plans.css";
import psicologico from "../assets/images/plans/Atendimento-psicologico.jpg";
import remoto from "../assets/images/plans/remoto.jpg";
import ace from "../assets/images/plans/crise.jpg";
import casal from "../assets/images/plans/terapia_casal.png";

export const projects = [
  {
    title: "Atendimento Presencial",
    description:
      "Você sente que precisa falar com alguém que realmente te escute? A psicoterapia presencial proporciona um ambiente seguro e acolhedor. \n Presencial: Atendimento na clínica: Rua Antônio Carlos Tacconi, 261-A.",
    img: psicologico,
    link: "/projects",
  },
  {
    title: "Atendimento Remoto",
    description:
      "Com a psicoterapia online, você recebe o mesmo acolhimento e suporte de um atendimento presencial, mas com a flexibilidade de se conectar de onde estiver. \n Aconselhamento psicológico através de videochamadas, no conforto de sua casa.",
    img: remoto,
    link: "/projects",
  },
  {
    title: "Psicoterapia de Casal e Familiar",
    description:
      "A psicoterapia de casal e familiar oferece um espaço seguro para o diálogo, ajudando a melhorar a comunicação, resolver dificuldades e fortalecer os vínculos afetivos.",
    img: casal,
    link: "/news",
  },
  {
    title: "Aconselhamento em Crises Emocionais",
    description:
      "Se você está passando por um momento difícil e precisa de um suporte psicológico imediato, a Psicologia de Emergência oferece um espaço de acolhimento e escuta ativa para ajudá-lo a lidar com crises emocionais.",
    img: ace,
    link: "/news",
  },
];

const GymPlans = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const visibleItems = 3;
  const intervalRef = useRef(null);

  const startAutoSlide = () => {
    intervalRef.current = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % projects.length);
    }, 5000);
  };

  const stopAutoSlide = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
  };

  useEffect(() => {
    startAutoSlide();
    return () => stopAutoSlide();
  }, []);

  const getVisibleProjects = () => {
    const items = [];
    for (let i = 0; i < visibleItems; i++) {
      items.push(projects[(currentIndex + i) % projects.length]);
    }
    return items;
  };

  const goToPrevious = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + projects.length) % projects.length
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % projects.length);
  };

  return (
    <section className="plans-section" id="plans">
      <br />
      <h2 className="about-title-white">Tipos de Atendimento</h2>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          overflow: "hidden",
          position: "relative",
        }}
        onMouseEnter={stopAutoSlide}
        onMouseLeave={startAutoSlide}
      >
        <button
          onClick={goToPrevious}
          style={{
            position: "absolute",
            left: "20px",
            top: "50%",
            transform: "translateY(-50%)",
            background: "#FAF9F7",
            borderRadius: "20px",
            border: "none",
            padding: "10px",
            cursor: "pointer",
            color: "#000",
            zIndex: 1,
          }}
        >
          &#8592;
        </button>

        <div
          style={{
            display: "flex",
            gap: "40px",
            transition: "transform 0.5s ease-in-out",
            padding: "20px 0",
            margin: "20px",
          }}
        >
          {getVisibleProjects().map((item, ind) => (
            <div
              key={ind}
              className="carousel-card"
              style={{ backgroundImage: `url(${item.img})` }}
            >
              <div
                style={{
                  position: "absolute",
                  bottom: "0",
                  width: "100%",
                  padding: "20px",
                  background: "rgba(0, 0, 0, 0.7)",
                  textAlign: "center",
                  height: "200px",
                }}
              >
                <h3 style={{ fontSize: "22px", marginBottom: "10px" }}>
                  {item.title}
                </h3>
                <p
                  style={{
                    fontSize: "14px",
                    lineHeight: "1.5",
                    whiteSpace: "pre-line",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <button
          onClick={goToNext}
          style={{
            position: "absolute",
            right: "20px",
            top: "50%",
            transform: "translateY(-50%)",
            background: "#FAF9F7",
            borderRadius: "20px",
            color: "#000",
            border: "none",
            padding: "10px",
            cursor: "pointer",
            zIndex: 1,
          }}
        >
          &#8594;
        </button>
      </div>
    </section>
  );
};

export default GymPlans;
